var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#434345",
    opacity: 0.01,
    isolate: "isolate"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M69,20.31l9.9,10.43A4,4,0,0,1,80,33.5V84.36A3.83,3.83,0,0,1,76,88H20a3.83,3.83,0,0,1-4-3.64V12a4,4,0,0,1,4-4H56.11a5,5,0,0,1,.66.1h.14a4,4,0,0,1,.69.22l.17.08a5,5,0,0,1,.5.29l.17.12a4.44,4.44,0,0,1,.56.5ZM24,80H72V38H56a4,4,0,0,1-4-4V16H24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2e264df81fa0974e02dbd3c9a844a016.svg";
export { ForwardRef as ReactComponent };